import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Col, Row, Form } from 'react-bootstrap'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { ToastContainer, toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import DatePicker from 'react-multi-date-picker'
import opacity from 'react-element-popper/animations/opacity'
import thai from '../../../components/Utils/DatePicker/thai'
import thai_th from '../../../components/Utils/DatePicker/thai_th'
import StudentQualified from '../../../components/StudentQualified/StudentQualified'
import CourseTerm from '../../../components/CourseTerm/CourseTerm'
import CourseService from '../../../service/courseService'
import useToken from '../../../App/useToken'
import 'react-toastify/dist/ReactToastify.css'
import './Create.css'

function CreateCourse() {
  const { major_name } = useParams()
  const { isAdmin, getToken } = useToken()
  const isUserAdmin = isAdmin()
  const token = getToken()

  const date = new Date()
  const [terms, setTerms] = useState([{ id: 'begin', name: '' }])
  const [name, setName] = useState()
  const [fullName, setFullName] = useState('')
  const [yearOfCourse, setYearOfCourse] = useState(date.getFullYear() + 543)
  const [description, setDescription] = useState('')
  const [amount, setAmount] = useState()
  const [file, setFile] = useState()
  const [majorCourseName, setMajorCourseName] = useState()
  const [isSpcApprove, setIsSpcApprove] = useState()
  const [majorCourseId, setMajorCourseId] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [qualifications, setQualifications] = useState([])

  const [selectedDateTermUnit, setSelectedDateTermUnit] = useState()
  const [selectedEndDateTermUnit, setSelectedEndDateTermUnit] = useState()
  const [selectedDateTermSpc, setSelectedDateTermSpc] = useState()
  const [selectedEndDateTermSpc, setSelectedEndDateTermSpc] = useState()

  useEffect(() => {
    const getMajorCourseInfo = async () => {
      const courseService = new CourseService()
      const res = await courseService.getInfoByMajorCourseName(
        major_name,
        token,
      )
      if (res.name) {
        setMajorCourseId(res._id)
        setIsLoading(false)
        setName(res.name)
        setFullName(`${res.name}-${yearOfCourse}`)
        setMajorCourseName(res.name)
        setIsSpcApprove(res.is_spc_approve)
      }
    }
    getMajorCourseInfo(major_name)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    const courseService = new CourseService()
    await courseService
      .createCourse(
        {
          majorCourseId: majorCourseId,
          majorCourseName: majorCourseName,
          name: fullName,
          description,
          amount,
          file,
          yearOfCourse,
          terms,
          qualifications,
          stardTermPeriodUnit: selectedDateTermUnit,
          endTermPeriodUnit: selectedEndDateTermUnit,
          stardTermPeriodSpc: selectedDateTermSpc,
          endTermPeriodSpc: selectedEndDateTermSpc,
        },
        token,
        isSpcApprove,
      )
      .then((res) => {
        window.location.href = `/majorcourses/${res?.data?.majorCourseName}/course/${res?.data?.name}`
      })
      .catch((err) => {
        alertError(err.message)
      })
  }

  function onCourseNameChange(name) {
    setName(name)
    setFullName(name + '-' + yearOfCourse)
  }

  function onYearOfCourseChange(yearOfCourse) {
    setYearOfCourse(yearOfCourse)
    setFullName(name + '-' + yearOfCourse)
  }

  const alertError = (msg) => {
    toast.error(msg, {
      theme: 'dark',
    })
  }
  return (
    <div className='create-course container'>
      {isUserAdmin && !isLoading && (
        <>
          <Breadcrumb className='course-breadcrumb'>
            <Breadcrumb.Item href='/majorcourses'>Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/majorcourses/${major_name}`}>
              {major_name}
            </Breadcrumb.Item>
            <Breadcrumb.Item active href='#'>
              {fullName}
            </Breadcrumb.Item>
          </Breadcrumb>
          <ToastContainer
            position='top-right'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <div className='title-container-left'>
                  <span className='title-text'>สถานะการเปิดรับสมัคร</span>
                </div>
                <Row className='mb-3'>
                  <Col md={12}>
                    <Form.Group
                      as={Col}
                      controlId='name'
                      onChange={(e) => onCourseNameChange(e.target.value)}>
                      <Form.Label>ชื่อหลักสูตร "{fullName}"</Form.Label>
                      <Form.Control required defaultValue={name} />
                    </Form.Group>
                  </Col>

                  <Col md={7}>
                    <Form.Group
                      controlId='yearOfCourse'
                      onChange={(e) => onYearOfCourseChange(e.target.value)}>
                      <Form.Label>
                        ปีงบประมาณที่เข้ารับการศึกษา (1 ต.ค. - 30 ก.ย.)
                      </Form.Label>
                      <Form.Control
                        type='number'
                        min='2565'
                        max='2585'
                        required
                        defaultValue={yearOfCourse}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group controlId='amount'>
                      <Form.Label>จำนวนผู้เข้ารับการศึกษา(ทั้งปี)</Form.Label>
                      <Form.Control
                        type='number'
                        min='1'
                        value={amount}
                        readOnly
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={12}>
                    <Form.Group
                      as={Col}
                      controlId='description'
                      onChange={(e) => setDescription(e.target.value)}>
                      <Form.Label>คำอธิบาย</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={10}
                        placeholder={name}
                        defaultValue={description}
                      />
                    </Form.Group>
                  </Col>
                  <Form.Group
                    as={Col}
                    controlId='file'
                    onChange={(e) => setFile(e.target.files[0])}>
                    <Form.Label>แนบคำสั่ง</Form.Label>
                    <Form.Control type='file' multiple />
                  </Form.Group>
                </Row>

                {/* HotFix Todo Verify */}
                <Row>
                  <Form.Group as={Col}>
                    <Form.Label>เปิดสมัครหน่วย</Form.Label>
                    <br />
                    <DatePicker
                      inputClass='form-control'
                      // calendar={thai}
                      locale={thai_th}
                      required
                      format='DD/MMMM/YYYY'
                      animations={[opacity()]}
                      value={selectedDateTermUnit}
                      disabled={!isUserAdmin}
                      onChange={(date) =>
                        setSelectedDateTermUnit(
                          new Date(date.year, date.month.index, date.day),
                        )
                      }
                    />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>หมดเขตสมัครหน่วย</Form.Label>
                    <br />
                    <DatePicker
                      inputClass='form-control'
                      // calendar={thai}
                      locale={thai_th}
                      required
                      format='DD/MMMM/YYYY'
                      animations={[opacity()]}
                      value={selectedEndDateTermUnit}
                      disabled={!isUserAdmin}
                      onChange={(date) =>
                        setSelectedEndDateTermUnit(
                          new Date(date.year, date.month.index, date.day),
                        )
                      }
                    />
                  </Form.Group>
                </Row>
                {isSpcApprove && (
                  <Row>
                    <Form.Group as={Col}>
                      <Form.Label>เปิดสมัครสาย</Form.Label>
                      <br />
                      <DatePicker
                        inputClass='form-control'
                        // calendar={thai}
                        locale={thai_th}
                        required
                        format='DD/MMMM/YYYY'
                        animations={[opacity()]}
                        value={selectedDateTermSpc}
                        disabled={!isUserAdmin}
                        onChange={(date) =>
                          setSelectedDateTermSpc(
                            new Date(
                              date.year,
                              date.month.index,
                              date.day,
                            ),
                          )
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label>หมดเขตสมัครสาย</Form.Label>
                      <br />
                      <DatePicker
                        inputClass='form-control'
                        // calendar={thai}
                        locale={thai_th}
                        required
                        format='DD/MMMM/YYYY'
                        animations={[opacity()]}
                        value={selectedEndDateTermSpc}
                        disabled={!isUserAdmin}
                        onChange={(date) =>
                          setSelectedEndDateTermSpc(
                            new Date(
                              date.year,
                              date.month.index,
                              date.day,
                            ),
                          )
                        }
                      />
                    </Form.Group>
                  </Row>
                )}
              </Col>
              {/* HotFix Todo Verify */}
              <Col md={6}>
                <div className='title-container-right'>
                  <span className='title-text'>คุณสมบัติที่หลักสูตรกำหนด</span>
                </div>
                <Row className='mb-3 qualification'>
                  <StudentQualified
                    setQualifications={setQualifications}
                    token={token}
                  />
                </Row>
              </Col>
            </Row>
            <Row className='add-term'>
              <div>
                รุ่น
                <FontAwesomeIcon icon={faPlus} />
              </div>
              <hr />
            </Row>

            <CourseTerm
              setAmount={setAmount}
              setTerms={setTerms}
              terms={terms}
            />

            <div className='btn-submit'>
              <Button variant='primary' type='submit'>
                บันทึก
              </Button>
            </div>
          </Form>
        </>
      )}
    </div>
  )
}

export default CreateCourse
